var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("section", { staticClass: "pb-10" }, [
    _c(
      "div",
      { staticClass: "bg-white shadowCard mb-4" },
      [
        _c(
          "LoadingOverlay",
          { attrs: { hasData: !_vm.isLoading, loading: _vm.isLoading } },
          [
            _c(
              "div",
              { staticClass: "px-8 pb-8 pt-8" },
              [
                _c("div", { staticClass: "md:col-span-1" }, [
                  _c(
                    "h3",
                    {
                      staticClass:
                        "text-lg font-semibold leading-6 text-primary-black",
                    },
                    [_vm._v(" Marketplace access permissions ")]
                  ),
                  _c(
                    "p",
                    {
                      staticClass:
                        "mt-4 text-base leading-5 font-normal text-primary-black",
                    },
                    [
                      _vm._v(
                        " Toggle between who you would like to have access to the Marketplace. "
                      ),
                    ]
                  ),
                ]),
                _c(
                  "FormGroup",
                  { staticClass: "mt-8 mb-8", attrs: { title: "" } },
                  [
                    _c("DefaultRadioButton", {
                      class: _vm.radioButtonClasses,
                      attrs: {
                        label: "Enabled",
                        value: _vm.MarketplaceAccessType.ALL,
                        name: _vm.radioButtonGroupName,
                        checked: _vm.isChecked(_vm.MarketplaceAccessType.ALL),
                      },
                      on: {
                        input: (accessType) =>
                          (_vm.chosenMarketplaceAccessType = accessType),
                      },
                    }),
                    _c("DefaultRadioButton", {
                      class: _vm.radioButtonClasses,
                      attrs: {
                        label: "Disabled",
                        value: _vm.MarketplaceAccessType.DISABLED,
                        name: _vm.radioButtonGroupName,
                        checked: _vm.isChecked(
                          _vm.MarketplaceAccessType.DISABLED
                        ),
                      },
                      on: {
                        input: (accessType) =>
                          (_vm.chosenMarketplaceAccessType = accessType),
                      },
                    }),
                    _c("DefaultRadioButton", {
                      class: _vm.radioButtonClasses,
                      attrs: {
                        label: "Allow access to the following managers",
                        name: _vm.radioButtonGroupName,
                        value: _vm.MarketplaceAccessType.SELECTED,
                        checked: _vm.isChecked(
                          _vm.MarketplaceAccessType.SELECTED
                        ),
                      },
                      on: {
                        input: (accessType) =>
                          (_vm.chosenMarketplaceAccessType = accessType),
                      },
                    }),
                    _c(
                      "div",
                      { staticClass: "flex pt-4" },
                      [
                        _c("ValidatableEmployeesMultiselect", {
                          attrs: {
                            error: "Select at least one manager",
                            outerError: _vm.managerMultiselectError,
                            disabled: _vm.managerMultiselectDisabled,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function ({
                                disabled,
                                invalid,
                                updateSelectedEmployees,
                                onClose,
                                value,
                              }) {
                                return [
                                  _c("ManagersMultiselect", {
                                    staticClass: "min-w-68",
                                    attrs: {
                                      additionalConditions:
                                        _vm.managerMultiselectConditions,
                                      value: value,
                                      invalid: invalid,
                                      parentStyles: "true",
                                      disabled: disabled,
                                      max: 10,
                                      placeholder: "Select manager",
                                    },
                                    on: {
                                      input: updateSelectedEmployees,
                                      close: onClose,
                                    },
                                  }),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.selectedManagersIds,
                            callback: function ($$v) {
                              _vm.selectedManagersIds = $$v
                            },
                            expression: "selectedManagersIds",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "flex justify-flex-start w-full" },
                  [
                    _c("UiButton", {
                      attrs: {
                        buttonText: "Update",
                        size: "lg",
                        disabled:
                          !_vm.managerMultiselectDisabled &&
                          _vm.selectedManagersIds.length === 0,
                        processing: _vm.processing,
                      },
                      on: { click: _vm.update },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }